import { ReactNode } from 'react';
import styles from './CommunityShotContainer.module.css';

type Props = {
  children: ReactNode;
};

export default function CommunityShotContainer({ children }: Props) {
  return <div className={styles.Container}>{children}</div>;
}
